import { useTheme } from '../hooks/useTheme';

import AuthProvider from './AuthProvider';
import { CartProvider } from './CartProvider';
import { MenuProvider } from './MenuProvider';
import OrderProvider from './OrderProvider';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      refetchInterval: 5 * 60 * 1000, // 5min
      refetchIntervalInBackground: false,
      staleTime: 5 * 60 * 1000, // 5min
      cacheTime: 15 * 60 * 1000, // 15 min
      retry: 1
    },
    mutations: {
      retry: 0
    }
  }
});

const AppProviders = ({ children }) => {
  const { getThemeVariable } = useTheme();
  return (
    <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <OrderProvider>
            <CartProvider>
              <MenuProvider>
                <div
                  style={{
                    background: getThemeVariable('background-primary'),
                    width: '100%',
                    height: '100%'
                  }}
                >
                  {children}
                </div>
              </MenuProvider>
            </CartProvider>
          </OrderProvider>
        </AuthProvider>
    </QueryClientProvider>
  );
};

export default AppProviders;
